import { render, staticRenderFns } from "./GeographicalTable.vue?vue&type=template&id=470daa6c"
import script from "./GeographicalTable.vue?vue&type=script&lang=js"
export * from "./GeographicalTable.vue?vue&type=script&lang=js"
import style0 from "./GeographicalTable.vue?vue&type=style&index=0&id=470daa6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports